import React, { useState } from 'react';
// import FormField from "./formField"
// import Input from "react-phone-number-input/input"
import PhoneInput from 'react-phone-number-input';
import './phoneFormField.css';

const PhoneFormField = ({ label, name, phone, onMyChange, errorsfunc }) => {
  return (
    <>
      <label className="mb0 pb0 k--label" htmlFor={name}>
        {label}
      </label>

      <PhoneInput
        id={name}
        name={name}
        defaultCountry="US"
        className={`${
          errorsfunc[name] ? `b--red` : ``
        } k--input w-100 db border-box w-100 mw-100 pa2 bg-white-30 hover-bg-white-70 outline-0 hover-gray ba k--input`}
        placeholder="Enter phone number"
        value={phone}
        onChange={onMyChange}
      />

      <p className="f7 ma0 pb0 green">Required Format xxx-xxx-xxxx</p>

      {errorsfunc.errors &&
        Object.entries(errorsfunc.errors).map(([e, v]) => (
          <p
            className="red f7 mb0 pb0"
            style={{
              // visibility: `${errorsfunc[name] ? "visible" : "hidden"}`,
              visibility: 'visible',
            }}
          >
            {v.message}
          </p>
        ))}
    </>
  );
};

export default PhoneFormField;
